<div
  rt-overlay-origin
  #timezoneDropdownTrigger="rtOverlayOrigin"
  [class.active]="timezoneDropdown.open"
  [attr.margin-tb-small-x]="hasMargin ? hasMargin : null"
  (click)="toggle(timezoneDropdown); dropdownToggle.emit(!timezoneDropdown.open)"
  class="timezone"
>
  <div #trigger>
    <ng-content />
  </div>
  @if (trigger.children.length === 0) {
    <div>
      @if (!dropdown && !short && !inputVariant) {
        <p>{{ timeZoneString }}</p>
      }
      @if (dropdown && !inputVariant && !short) {
        <div
          [class.dropdownOpened]="timezoneDropdown.open"
          class="only-dropdown"
          layout
          layout-align-items-center
        >
          <p>{{ timeZoneString }}</p>
          <div class="arrow-dropdown">
            <rt-icon [name]="timezoneDropdown.open ? 'arrow-drop-up' : 'arrow-drop-down'" />
          </div>
        </div>
      }
      @if (short && !inputVariant) {
        <rt-button variant="plain" [dropdownOpened]="timezoneDropdown.open">
          GMT<br />
          {{ timeZoneString }}
        </rt-button>
      }
      @if (inputVariant) {
        <rt-input
          [hasDropdownIndicator]="true"
          [value]="timeZoneString"
          [readOnly]="true"
          [class.dropdownOpened]="timezoneDropdown.open"
          variant="rounded"
        />
      }
    </div>
  }
</div>
<ng-template
  #timezoneDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [origin]="timezoneDropdownTrigger"
  [positions]="positions"
  [minWidth]="dropdownMinWidth"
  (backdropClick)="toggle(timezoneDropdown); dropdownToggle.emit(false)"
>
  <rt-time-zone-picker-dropdown
    (close)="toggle(timezoneDropdown)"
    (zoneSelect)="onZoneSelect($event, timezoneDropdown)"
  />
</ng-template>
